module.exports = __webpack_public_path__ + "static/media/1da4cd24-4793-4d30-b1f2-ef739b37ffb4.13432e08.JPG";